// extracted by mini-css-extract-plugin
export default {"container":"styles_container__85muz","content":"styles_content__KqFAA","blinker":"styles_blinker__zNqVN"};